import React from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "./App";

/**
 * Narrow data-router bootstrap for PatientMeshFE.
 * App keeps its nested <Routes>; this only enables data-router APIs (e.g. useBlocker).
 */
export function createAppRouter() {
  return createBrowserRouter(
    [{ path: "*", element: <App /> }],
    {
      // Adopt the React Router v7 transition behavior now, avoiding the
      // future-flag warning and making navigation scheduling explicit.
      future: { v7_startTransition: true },
    },
  );
}
